﻿import { ListingCardFavoriteInteractions } from '../listing-favorites/ListingCardFavoriteInteractions';

export class GeneralListingResultComponentViewModel {
    constructor() {
        const listingCardInter = new ListingCardFavoriteInteractions("btn--fav");
        listingCardInter.setFavoriteEvents();
    }
}

if (document.getElementById("general-listing-result-component")) {
    let generalListingVM = new GeneralListingResultComponentViewModel();
}